import classnames from 'classnames';
import React, { CSSProperties, ReactNode, useEffect, useState } from 'react';

import styles from './ButtonGroup.module.scss';

export interface ButtonGroupProps {
  labels: ReactNode[];
  activeIndex?: number;
  onClick?: (index: number) => void;
  customActiveBackgroundColor?: string;
  className?: string;
}

export const ButtonGroup = ({
  labels,
  activeIndex = 0,
  onClick,
  customActiveBackgroundColor,
  className,
  ...rest
}: ButtonGroupProps) => {
  const [index, setIndex] = useState(activeIndex);

  useEffect(() => {
    setIndex(activeIndex);
  }, [activeIndex]);

  const handleClick = (clickIndex: number) => () => {
    setIndex(clickIndex);
    onClick?.(clickIndex);
  };

  const activeStyle = customActiveBackgroundColor
    ? ({ '--custom-active-bg': customActiveBackgroundColor } as CSSProperties)
    : undefined;

  return (
    <div
      className={classnames(styles.root, className)}
      role="group"
      data-button-group
      {...rest}
    >
      {labels.map((label, _index) => {
        const isActive = index === _index;

        return (
          <button
            key={_index}
            type="button"
            data-testid={`button-group-item-${_index}`}
            className={classnames(styles.item, {
              [styles.itemActive]: isActive,
            })}
            data-button-group-item
            onClick={handleClick(_index)}
            data-is-active={isActive}
            style={isActive ? activeStyle : undefined}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};
